module.exports = __webpack_public_path__ + "static/media/relove-logo.c008a557.png";